    export let layout = "horizontal";
    export let maxSuggest = "20";
    export let title = "You Might Also Like...";
    export let sources = "related_views,similar_products,related_recently_viewed,related_cart,related_purchase";
    export let imgRatio = "1:1";

    export const mediaQueries = [
    {device: 'mobile', query: '(max-width: 480px)'},
    {device: 'tablet', query: '(min-width: 481px) and (max-width: 785px)'},
    {device: 'desktop', query: '(min-width: 786px)'}
]